import { withErrorBoundary } from "@sentry/nextjs";
import clsx from "clsx";
import { FC, HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";
import { Brick } from "components/Atoms/Brick";
import { ResourceDivider } from "components/Organisms/MegaNavigation/ResourceDivider";
import { ArrowPointerRight } from "icons/ArrowPointerRight";
import { ComponentMoleculesBrickList } from "types/graphql/generated";
import { GeneralRoutingLinkButton } from "../GeneralRoutingLinkButton";
interface BrickListProps extends Pick<HTMLAttributes<HTMLDivElement>, "className"> {
  content: ComponentMoleculesBrickList;
  title?: string;
  isMobile?: boolean;
}

const BrickList: FC<BrickListProps> = withErrorBoundary(({ content, title, isMobile, className = "" }) => {
  const paddingClasses = clsx({
    "pt-6 lg:pt-4": title,
  });

  const brickMobileClasses = clsx({
    "pt-3": isMobile && content?.bricks[0]?.imageSize === "md",
  });

  return (
    <div className={twMerge("flex w-full flex-col lg:gap-2 lg:pt-2", paddingClasses, className)}>
      {title && <h4 className="px-6 pb-4 text-sm font-semibold text-fog-80 opacity-60 lg:px-4 lg:pb-0">{title}</h4>}
      {content?.bricks.map((brick) => (
        <div className="relative contents" key={brick.id}>
          {isMobile && brick.imageSize !== "md" && (
            <div className="relative">
              <ResourceDivider />
            </div>
          )}
          <Brick
            title={brick.title}
            subTitle={brick.subTitle}
            imageUrlHash={
              !isMobile || (isMobile && brick.imageSize === "md") ? brick.image?.data?.attributes?.hash : undefined
            }
            imageAlt={
              !isMobile || (isMobile && brick.imageSize === "md") ? brick.image?.data?.attributes?.url : undefined
            }
            imageSize={!isMobile || (isMobile && brick.imageSize === "md") ? brick.imageSize : undefined}
            titleTagLabel={brick.titleTag?.label}
            titleTagIconUrlHash={brick.titleTag?.icon?.data?.attributes?.hash}
            titleTagIconAlt={brick.titleTag?.icon?.data?.attributes?.alternativeText}
            titleTagBgColor={brick.titleTag?.bgColor}
            href={brick.url}
            hoverEffect={!isMobile ? brick.hoverEffect : false}
            key={brick.id}
            className={twMerge("lg:px-unset px-6 py-4 lg:px-4 lg:py-3", brickMobileClasses)}
          />
        </div>
      ))}
      {content?.secondaryButton && (
        <div className="relative mx-6 h-full w-max pb-6 pt-4 lg:mx-4 lg:px-0 lg:pb-0">
          {isMobile && content?.bricks[0].imageSize !== "md" && <ResourceDivider />}
          <GeneralRoutingLinkButton
            secondary
            compact
            href={content?.secondaryButton?.url}
            rightIcon={<ArrowPointerRight fill="white" height={16} width={16} />}
            className="rounded-full px-3 text-sm"
          >
            {content?.secondaryButton?.label}
          </GeneralRoutingLinkButton>
        </div>
      )}
    </div>
  );
}, {});

export { BrickList };
